(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/redirect-to-slug/assets/javascripts/redirect-to-team-slug-container.js') >= 0) return;  svs.modules.push('/components/marketplace/redirect-to-slug/assets/javascripts/redirect-to-team-slug-container.js');

'use strict';

const selectors = svs.components.marketplaceData.selectors;
const _svs$components$marke = svs.components.marketplace.redirectToSlug,
  RedirectToSlug = _svs$components$marke.RedirectToSlug,
  helpers = _svs$components$marke.helpers;
const mapStateToProps = (state, _ref) => {
  var _selectors$teams$sele;
  let _ref$match = _ref.match,
    _ref$match$params = _ref$match.params,
    groupId = _ref$match$params.groupId,
    teamPathName = _ref$match$params.teamPathName,
    retailerPathName = _ref$match$params.retailerPathName,
    additionalPath = _ref$match$params.additionalPath,
    path = _ref$match.path;
  return {
    additionalPath,
    name: (_selectors$teams$sele = selectors.teams.selectTeam(state, {
      id: groupId
    })) === null || _selectors$teams$sele === void 0 ? void 0 : _selectors$teams$sele.name,
    id: Number(groupId),
    prePath: helpers.getPathBeforeParam(path, ':groupId'),
    slug: teamPathName || retailerPathName || ''
  };
};
setGlobal('svs.components.marketplace.redirectToSlug.RedirectToTeamSlugContainer', ReactRedux.connect(mapStateToProps)(RedirectToSlug));

 })(window);